// Import test kit images
import beforeYouGoImage from '../../assets/before-you-go-image-1.webp';
import covidAg from '../../assets/covid-ag.webp';
import covidTestKit2 from '../../assets/covid-test-kit2.webp';
import testKits4 from '../../assets/test-kits-4.webp';

export const covidTestKitsProducts = [
    {
        image: beforeYouGoImage,
        alt: 'Before You Go COVID-19 Test Kit'
    },
    {
        image: covidAg,
        alt: 'Onsite Test'
    },
    {
        image: covidTestKit2,
        alt: 'COVID-19 Test Kit'
    },
    {
        image: testKits4,
        alt: 'COVID-19 Test Kits Bulk'
    }
]; 